// src/services/appointments.js
// Randevu talebi gönderimi: Web3Forms ile mail + Firestore kaydı.

import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

// Landing.jsx'teki <select> option value'ları ile birebir eşleşmeli.
export const SERVICE_LABELS = {
  'kilo-yonetimi': 'Kilo Yönetimi',
  'spor-beslenmesi': 'Spor Beslenmesi',
  'adölesan-beslenmesi': 'Adölesan Beslenmesi',
  'hastalıklarda-beslenme': 'Hastalıklarda Beslenme',
  'fitness-danışmanlıgıi': 'Fitness Danışmanlığı',
  'surdurulebilir-beslenme': 'Sürdürülebilir Beslenme',
};

export const serviceLabel = (value) => SERVICE_LABELS[value] || value;

const WEB3FORMS_ENDPOINT = 'https://api.web3forms.com/submit';

/**
 * Randevu talebini Web3Forms üzerinden mail olarak gönderir.
 * Asla exception fırlatmaz; mailin gidip gitmediğini boolean olarak döner.
 */
export const sendAppointmentEmail = async (data) => {
  const accessKey = process.env.REACT_APP_WEB3FORMS_KEY;

  if (!accessKey) {
    console.error('REACT_APP_WEB3FORMS_KEY tanımlı değil, mail gönderilemedi.');
    return false;
  }

  try {
    const response = await fetch(WEB3FORMS_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        access_key: accessKey,
        subject: `Yeni Randevu Talebi — ${data.name}`,
        from_name: 'Dyt. Kerem Barbak Web Sitesi',
        replyto: data.email,
        'Ad Soyad': data.name,
        'E-posta': data.email,
        'Telefon': data.phone,
        'Hizmet Türü': serviceLabel(data.service),
        'Mesaj': data.message || '-',
      }),
    });

    const result = await response.json();
    return result.success === true;
  } catch (error) {
    console.error('Randevu maili gönderilemedi:', error);
    return false;
  }
};

/**
 * Randevu talebini Firestore'a kaydeder.
 * Asla exception fırlatmaz; kaydın başarılı olup olmadığını boolean olarak döner.
 */
export const saveAppointment = async (data, mailSent) => {
  try {
    await addDoc(collection(db, 'appointments'), {
      name: data.name,
      email: data.email,
      phone: data.phone,
      service: data.service,
      message: data.message || '',
      status: 'new',
      mailSent,
      createdAt: serverTimestamp(),
    });
    return true;
  } catch (error) {
    console.error('Randevu kaydı oluşturulamadı:', error);
    return false;
  }
};

const RATE_LIMIT_MS = 60 * 1000;
const RATE_LIMIT_STORAGE_KEY = 'appointmentLastSubmit';

// localStorage gizli sekmede veya çerezleri kapalı tarayıcıda hata fırlatabilir;
// bu durumda rate limit sessizce devre dışı kalır, gönderim engellenmez.
const readLastSubmit = () => {
  try {
    return Number(localStorage.getItem(RATE_LIMIT_STORAGE_KEY)) || 0;
  } catch {
    return 0;
  }
};

const writeLastSubmit = (timestamp) => {
  try {
    localStorage.setItem(RATE_LIMIT_STORAGE_KEY, String(timestamp));
  } catch {
    // yoksay
  }
};

/**
 * Randevu formunun tek giriş noktası.
 *
 * Dönen değerler:
 *   { ok: true, skipped: 'bot' }                  — honeypot doluydu, hiçbir şey gönderilmedi
 *   { ok: true, mailSent: bool, saved: bool }     — en az biri başarılı
 *   { ok: false, reason: 'rate-limited' }         — 60 saniye dolmadan tekrar denendi
 *   { ok: false, reason: 'failed' }               — hem mail hem kayıt başarısız
 */
export const submitAppointmentRequest = async (data, { honeypot = '' } = {}) => {
  if (honeypot) {
    return { ok: true, skipped: 'bot' };
  }

  if (Date.now() - readLastSubmit() < RATE_LIMIT_MS) {
    return { ok: false, reason: 'rate-limited' };
  }

  const mailSent = await sendAppointmentEmail(data);
  const saved = await saveAppointment(data, mailSent);

  if (!mailSent && !saved) {
    return { ok: false, reason: 'failed' };
  }

  writeLastSubmit(Date.now());
  return { ok: true, mailSent, saved };
};
